import { Box } from "@mui/material";
import GlobalDialog from "shared/components/GlobalDialog";
import InAppRoutes from "pages/main";
import { Routes } from "react-router";
import useStore from "zustand-store";
import Loader from "components/Loader";

function App() {

  const globalDialog = useStore(state => state.globalDialog);
  const isFetching = useStore(state => state.isFetching);

  return (
    <Box className="App">
      <Routes>
        {InAppRoutes}
      </Routes>
      {isFetching && <Loader />}
      <GlobalDialog
        icon={globalDialog.icon}
        isOpen={globalDialog.isOpen}
        title={globalDialog.title}
        description={globalDialog.description}
        actionTitle={globalDialog.actionTitle}
        action={globalDialog.action}
      />
    </Box>
  );
}

export default App;
